import React, { FC } from "react";
import { Col, Row, Image} from "antd";
import styled from "styled-components";
import background from "../../assets/images/image1.png";
import FooterPublic3D from "../../Components/FooterPublic3D";
import smallBgd2 from "../../assets/images/image3.png";
import printerhub1 from "../../assets/images/printerhub1.png"
import printerhub2 from "../../assets/images/printerhub2.png"
import printerhub3 from "../../assets/images/printerhub3.png"
import { Button3D } from "../../Components/Button3D";
import {
  ExpertText,
  HeaderTitle,
  MediumHeaderTitle,
} from "../../Components/Text3D";
import { ImageBox } from "../../Components/ImageBox3D";
import HeaderComponent from "../../Components/HeaderComponents";
import Plastic3D from "../../assets/images/Plastic.png";
import { useHistory } from "react-router-dom";
import CollapseB from "../../Components/CollapseB";

const AboutUsContainer = styled.div`
  display: flex;
  font-family: "Rogan";
  flex-direction: column;
  width: "100%";
  .how-printer-hub-section {
    ul {
      list-style-type: none;
      li {
        div {
          font-size: 20px;
        }
      }
    }
    .printer-hub-sc {
      text-align: center;
      display: flex;
      flex: 1;
      justify-content: center;
      margin-bottom: 8px;
      span {
        border: 1px solid #75706b;
        border-radius: 50%;
        padding: 8px;
        font-size: 16px;
        height: 36px;
        width: 36px;
        color: #75706b;
      }
    }
  }
`;
const HowDoesItWorkContainter = styled.div`
  display: flex;
  flex-direction: column;
`;
const Ul = styled.ul`
  margin-bottom: 0;
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  font-size: 1.2rem;
  .li-design-bar-85 {
    color: #822ef5;
  }
  .li-design-bar-10 {
    color: #b4b4b4;
    margin-left: 85%;
  }
  .li-design-bar-5 {
    color: #505050;
  }
`;
const ProgressDiv = styled.div`
  display: flex;
  flex-flow: wrap;
  margin: 1rem 0;
  width: 100%;
  height: 1rem;
  .design-bar-85 {
    width: 85%;
    background-color: #822ef5;
  }
  .design-bar-10 {
    width: 10%;
    background-color: #b4b4b4;
  }
  .design-bar-5 {
    width: 5%;
    background-color: #505050;
  }
`;
const MobileProgressBar = styled.div`
  display: none;
  flex-direction: column;
  @media screen and (max-width:900px){
    display: flex;
  }
`
const MobileHideProgressDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width:900px){
    display: none;
  }
`
const StyledUl = styled.ul`
display: inline-flex;
flex-flow: row;
/* justify-content: space-between; */
align-items: center;
width: 100%;
font-size: 1rem;
`
const AboutUSPageScreen: FC = () => {
  const history = useHistory();
  return (
    <>
      <AboutUsContainer>
        <HeaderComponent />
        <ImageBox bg={`url(${background})`} height="300px">
          <HeaderTitle>Frequently Asked Questions</HeaderTitle>
        </ImageBox>

        <Col
          lg={{ span: 21, offset: 3 }}
          md={{ span: 21, offset: 3 }}
          sm={{ span: 22, offset: 1 }}
          xs={{ span: 22, offset: 1 }}
        >
          <Row style={{ padding: "3rem 0" }}>
            <Col lg={{ span: 13 }} md={{ span: 13 }} sm={{ span: 24 }}>
              <HowDoesItWorkContainter>
                <MediumHeaderTitle dark style={{ marginBottom: "1rem" }}>
                  How it Works
                </MediumHeaderTitle>
                <CollapseB />
              </HowDoesItWorkContainter>
            </Col>
            <Col
              // xxl={{span:10, offset:1}}
              lg={{ span: 10, offset: 1 }}
              md={{ span: 10, offset: 1 }}
              sm={{ span: 24 }}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingBottom: "1rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  backgroundImage: `url(${Plastic3D})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
              {/* <img src={Plastic3D} alt="" width='100%' height='auto' style={{alignSelf:'center'}} /> */}
            </Col>
          </Row>
        </Col>
        <Col
          style={{ marginBottom: "1remx" }}
          lg={{ span: 20, offset: 2 }}
          md={{ span: 20, offset: 2 }}
          sm={{ span: 22, offset: 1 }}
          xs={{ span: 22, offset: 1 }}
        >
          <Row>
            <Col>
              <MediumHeaderTitle dark> COMMISSION SYSTEM</MediumHeaderTitle>
              <ExpertText
                dark
                style={{ fontSize: "20px", wordSpacing: 2, lineHeight: "30px" }}
              >
                You are a designer and you want to sell your 3D models optimized
                for 3D printing? Thanks to 3Dprintit, you can earn money with
                your files STL, OBJ, CAD, etc.! For each download, you will
                receive 85% of the net selling price via Stripe. 3Dprintit keeps
                15% of commission which is used to finance bank fees (about 5%)
                and then all the costs related to the technical maintenance of
                the platform: hosting, bandwidth, accounting, email
                communications, translations, etc. There is no subscription
                system or fixed fee to pay. You sell, you win!
              </ExpertText>
              <MobileHideProgressDiv>
                <Ul>
                  <li className="li-design-bar-85">Designer/Printer 85%</li>
                  <li className="li-design-bar-5">Banking Fees 5%</li>
                </Ul>
                <ProgressDiv>
                  <div className="design-bar-85"></div>
                  <div className="design-bar-10"></div>
                  <div className="design-bar-5"></div>
                </ProgressDiv>
                <Ul style={{ marginBottom: "1rem" }}>
                  <li className="li-design-bar-10">3Dprintit 10%</li>
                </Ul>
              </MobileHideProgressDiv>
              <MobileProgressBar>
                <StyledUl>
                  <li style={{ color: "#822ef5", width: "fit-content" }}>
                    Designer/Printer 85%
                  </li>
                  <div
                    style={{
                      height: "10px",
                      background: "#822ef5",
                      width: "10rem",
                      marginLeft: "1rem",
                    }}
                  ></div>
                </StyledUl>
                <StyledUl>
                  <li style={{ color: "#b4b4b4" }}>3Dprintit 10%</li>
                  <div
                    style={{
                      height: "10px",
                      background: "#b4b4b4",
                      width: "10%",
                      marginLeft: "1rem",
                    }}
                  ></div>
                </StyledUl>
                <StyledUl>
                  <li style={{ color: "#505050" }}>Banking Fees 5%</li>
                  <div
                    style={{
                      height: "10px",
                      background: "#505050",
                      width: "5%",
                      marginLeft: "1rem",
                    }}
                  ></div>
                </StyledUl>
              </MobileProgressBar>
              <ExpertText
                dark
                style={{
                  fontSize: "1.2rem",
                  lineHeight: "1.8rem",
                  wordSpacing: 2,
                }}
              >
                What types of printers do you offer? We offer all types of
                printers from hobbyist Desktop FDM Printers like Creality Ender
                3 V2, Voron, Anycubic, Wanhao, Artillery, Flashforged, Anycubic,
                Elegoo, CoreXY to Prusa. We also have resin printers like
                Formlabs Form 2. We also have a range of Commercial Grade
                Printers too like the
              </ExpertText>
              <ul>
                <li>
                  <ExpertText dark> HP Multi Jet Fusion 4200</ExpertText>
                </li>
                <li>
                  <ExpertText dark>HP Multi Jet Fusion 580 Colour</ExpertText>
                </li>
                <li>
                  <ExpertText dark>BigRep ONE</ExpertText>
                </li>
                <li>
                  <ExpertText dark>Formlabs Form 2</ExpertText>
                </li>
                <li>
                  <ExpertText dark>Markforged Metal X</ExpertText>
                </li>
                <li>
                  <ExpertText dark>Markforged X7</ExpertText>
                </li>
                <li>
                  <ExpertText dark>Stratasys Fortus 450MC</ExpertText>
                </li>
                <li>
                  <ExpertText dark>Stratasys F270</ExpertText>
                </li>
                <li>
                  <ExpertText dark>Stratasys J750</ExpertText>
                </li>
              </ul>
            </Col>
          </Row>
        </Col>
        <Col
          className="how-printer-hub-section"
          style={{ marginBottom: "1rem" }}
          lg={{ span: 20, offset: 2 }}
          md={{ span: 20, offset: 2 }}
          sm={{ span: 22, offset: 1 }}
          xs={{ span: 22, offset: 1 }}
        >
          <Row>
            <MediumHeaderTitle dark>
              {" "}
              How to become a printer hub ?
            </MediumHeaderTitle>
            <ExpertText
              dark
              style={{ fontSize: "20px", wordSpacing: 2, lineHeight: "30px" }}
            >
              Thank you for your interest in becoming a printer hub on our
              marketplace. It's easy to join, and we're excited to have you
              onboard!
              <br />
              To become a printer hub on our website, you need to become a
              seller and also complete payment setup through stripe. Please
              follow these simple steps:
              <br />
              If not registered yet,
              <ul>
                <li>
                  <ExpertText dark>
                    1. If you are not registered in our website, please click on
                    "Become a seller" from the header menu.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    2. Fill out the signup form, activate your account and move
                    to homepage.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    3. Once logged in, you will be prompted with complete
                    payment banner in header of the homepage. Complete the
                    onboarding steps from stripe.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    4. Once finished, you can now move to dashboard from the
                    dropdown menu in the top right(click the profile name), and
                    add new printer from the printers tab.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    5. Your printer will be available for the customers to
                    request, complete your request from the orders page and get
                    paid.
                  </ExpertText>
                </li>
              </ul>
              <br />
              If registered, and you want to enroll as printer hub as well, then
              <ul>
                <li>
                  <ExpertText dark>1. Login to your account.</ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    2. Click "Become a seller" from the dropdown menu in the top
                    right(click your profile name).
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    3. You will be prompted to complete your payment, click add
                    your payment and complete the onboarding steps from stripe.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    4. Once finished, you can now move to dashboard from the
                    dropdown menu in the top right(click the profile name), and
                    add new printer from the printers tab.
                  </ExpertText>
                </li>
                <li>
                  <ExpertText dark>
                    5. Your printer will be available for the customers to
                    request, complete your request from the orders page and get
                    paid.
                  </ExpertText>
                </li>
              </ul>
            </ExpertText>
            <Row gutter={[32, 32]}>
              <Col span={8}>
                <Image width={"100%"} src={printerhub1} />
                <div className="printer-hub-sc">
                  <span className="sc-label">1</span>
                </div>
              </Col>
              <Col span={8}>
                <Image width={"100%"} src={printerhub2} />
                <div className="printer-hub-sc">
                  <span className="sc-label">2</span>
                </div>
              </Col>
              <Col span={8}>
                <Image width={"100%"} src={printerhub3} />
                <div className="printer-hub-sc">
                  <span className="sc-label">3</span>
                </div>
              </Col>
            </Row>
          </Row>
        </Col>
        <ImageBox
          bg={`url(${smallBgd2})`}
          height="300px"
          style={{ background: "#000" }}
        >
          <MediumHeaderTitle>
            Put Your Parts Into Production Today
          </MediumHeaderTitle>
          <Button3D
            style={{
              backgroundColor: "#1196DD",
              border: "none",
              color: "white",
              marginTop: "2rem",
            }}
            onClick={() => history.push("/design/upload")}
          >
            GET INSTANT QUOTE
          </Button3D>
        </ImageBox>
        <FooterPublic3D />
      </AboutUsContainer>
    </>
  );
};

export default AboutUSPageScreen;
